import { Typography } from '@mui/material';
import styled from 'styled-components';

interface InfoCardProp {
  title: string;
  desc: number | string;
}

const InfoCardWrap = styled.div`
  width: 100%;
  max-width: 100%;
  height: 100%;
  padding: 0.5rem;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

export default function InfoCard({ title, desc }: InfoCardProp) {
  return (
    <InfoCardWrap>
      <Typography variant="h6">{title}</Typography>
      <Typography variant="h5">{desc}</Typography>
    </InfoCardWrap>
  );
}
